import type { EventUserEntity } from './store/eventApi';

export const areItemsUnique = (array: any[]) => {
  const uniqueItems = new Set(array);
  return uniqueItems.size === array.length;
};

export function getAttendeeDisplayName(
  eu: EventUserEntity | null | undefined
): string {
  if (!eu) return '';
  const nick = eu.eventNickname?.trim();
  if (nick) return nick;
  return eu.user?.profile?.name || eu.user?.email || eu.userId || '';
}
